// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"004d303d","71":"324a4bd0","85":"eeafc44a","547":"0e39ab7a","890":"f0cd4fd1"}[chunkId] + ".chunk.css";
};